import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericItemListComponent } from './generic-item-list.component';

@NgModule({
  declarations: [GenericItemListComponent],
  imports: [CommonModule],
  exports: [GenericItemListComponent],
})
export class GenericItemListModule {}
